module.exports = __webpack_public_path__ + "static/media/Entreprise-Valorisation-Immobiliere-Vaud.6e842696.jpg";